export default __webpack_public_path__ + "static/media/Error.17987539.svg";